// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fa772ff2","453":"792c9085","455":"cdd8539b","977":"b2fe00cc"}[chunkId] + ".chunk.js";
};